// extracted by mini-css-extract-plugin
export default {"container":"Header2_container__Nuifg","breadcrumb":"Header2_breadcrumb__fzFr2","background-image":"Header2_background-image__NLthd","gray-overlay":"Header2_gray-overlay__lYNkS"};